import React, { useEffect, useRef, useState } from "react";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import * as func from "../../common/manipurCommon/FunctionCalls";
import * as api from "../../common/manipurCommon/API";
import { usePermissions } from "../../common/PermissionContext";
import { useLocation, Link } from "react-router-dom";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Swal from "sweetalert2";
import Select from "react-select";
import Utils from "../../common/manipurCommon/Utils";

const RolePermission = () => {

    const [rolesList, setRolesList] = useState<any[]>([]);
    const [permissionsList, setPermissionsList] = useState<any[]>([]);
    const [rolePermissionsList, setRolePermissionsList] = useState<any[]>([]);
    const [searchInput, setSearchInput] = useState("");
    const [roleId, setRoleId] = useState("");
    const [permissionId, setPermissionId] = useState("");
    const [rolePermissionId, setRolePermissionId] = useState("");
    const [rolePermissionStatus, setRolePermissionStatus] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    useEffect(() => {
        async function fetchRolePermission() {
            setIsLoading(true);
            const response = await func.listRolesPermission();
            setRolePermissionsList(Array.isArray(response) ? response : [])
            setIsLoading(false);
        }
        fetchRolePermission();
    }, [])

    const filteredData = rolePermissionsList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const permissionNameRender = (rowData) => {
        return <span>{rowData.permissionName}</span>;
    };

    const roleRender = (rowData) => {
        return <span>{rowData.roleName}</span>;
    };

    const rolePermissionStatusRender = (rowData) => {
        return <span>{(rowData.rolePermissionStatus == 1) ? "Active" : "Inactive"}</span>;
    };

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editPermission(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const deleteDetails = (rowData) => {
        const permId = rowData.rolePermissionId;
        return (
            <Link to="#" onClick={() => deleteRolePermission(permId)}>
                <i className="feather-trash"></i>Delete
            </Link>
        );
    };

    async function newRolePermission() {
        setIsEdit(false)
        setOpenModal(true)
        setPermissionId("");
        setRoleId("");
        const rolesResponse = await func.listRoles();
        setRolesList(Array.isArray(rolesResponse) ? rolesResponse : [])
    }


    async function editPermission(rowData) {
        const rolePermId = rowData.rolePermissionId;
        setIsEdit(true)
        setOpenModal(true)
        const roleResponse = await func.listRoles();
        setRolesList(Array.isArray(roleResponse) ? roleResponse : [])
        const permResponse = await func.listPermission();
        setPermissionsList(Array.isArray(permResponse) ? permResponse : [])
        const getDetails = await func.getRolePermission(rolePermId);
        setRolePermissionId(rolePermId)
        setPermissionId(getDetails.rolePermissionPemId);
        setRoleId(getDetails.rolePermissionRoleId);
        setRolePermissionStatus(getDetails.rolePermissionStatus)
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateRolePermission();
            } else {
                if (roleId && permissionId) {
                    const formData = new FormData();
                    formData.append("roleId", roleId);
                    formData.append("permissionId", permissionId);

                    const createRolePermission = api.AddRolePermission;
                    fetch(createRolePermission, {
                        method: "POST",
                        headers: {
                            "Authorization": 'Bearer ' + Utils.getAccessToken()
                        },
                        body: formData
                    })
                        .then((response) => response.json())
                        .then((result) => {
                            if (result.error == false) {
                                Swal.fire({
                                    title: 'Success',
                                    text: result.message,
                                    icon: 'success',
                                    confirmButtonText: 'OK',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                }).then((res) => {
                                    if (res.isConfirmed) {
                                        window.location.reload(); // 🔁 Reload only after OK is clicked
                                    }
                                });
                            } else {
                                if (result.code == 401) {
                                    Utils.logoutUser();
                                }
                                Swal.fire({
                                    title: 'Error',
                                    text: result.message,
                                    icon: 'error',
                                    confirmButtonText: 'OK',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                }).then((res) => {
                                    if (res.isConfirmed) {
                                        window.location.reload(); // 🔁 Reload only after OK is clicked
                                    }
                                });
                            }
                        })
                }
            }
        }
    }

    function updateRolePermission() {
        const formData = new FormData();
        formData.append("roleId", roleId);
        formData.append("permissionId", permissionId);
        formData.append("status", rolePermissionStatus);

        const updatePermission = api.UpdateRolePermission + '/' + rolePermissionId;
        fetch(updatePermission, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    function deleteRolePermission(permId) {
        const deletePermission = api.DeleteRolePermission + '/' + permId;
        fetch(deletePermission, {
            method: "DELETE",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })

    }

    return (
        <>
            {isLoading && (

                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1500px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Role Permissions</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn"
                                            onClick={() => { newRolePermission() }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px", padding: "0px" }}
                                            title="Create Role Permission">
                                            <i className="feather-plus" />&nbsp;
                                        </Link>
                                        : null
                                    }
                                </div>
                            </div>
                            <div className="row col-lg-12 mb-10">
                                <div className="col-lg-12 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="roleName"
                                                header="Role Name"
                                                body={roleRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="permissionName"
                                                header="Permission Name"
                                                body={permissionNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="rolePermissionStatus"
                                                header="Permission Status"
                                                body={rolePermissionStatusRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            {currentPermissions.includes("edit") ?
                                                <Column
                                                    className="text-link"
                                                    body={editDetails}
                                                ></Column>
                                                : null
                                            }
                                            {currentPermissions.includes("delete") ?
                                                <Column
                                                    className="text-link"
                                                    body={deleteDetails}
                                                ></Column>
                                                : null
                                            }
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {
                openModal && (
                    <Modal
                        show={openModal}
                        size="md"
                        centered>
                        <ModalHeader>
                            <ModalTitle>
                                <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} Role Permission</h4>
                            </ModalTitle>
                            <Button
                                variant=""
                                className="btn-close"
                                onClick={() => setOpenModal(false)}
                            ></Button>
                        </ModalHeader>
                        <ModalBody>
                            <form ref={formRef}>
                                <div className="col-lg-12 mb-10">
                                    <label className="sortbytitle"><h6>Role</h6></label>
                                    <Select
                                        value={rolesList.find(role => role.roleId === roleId) ? {
                                            value: roleId,
                                            label: rolesList.find(role => role.roleId === roleId).roleName
                                        } : null}
                                        onChange={async (e) => {
                                            setRoleId(e.value);
                                            const permResponse = await func.listPermission();
                                            setPermissionsList(Array.isArray(permResponse) ? permResponse : [])
                                        }}
                                        required
                                        placeholder="Select Role"
                                        options={rolesList.map(role => ({
                                            value: role.roleId,
                                            label: role.roleName
                                        }))}>
                                    </Select>
                                    <div className="mb-10">
                                        <label className="sortbytitle"><h6>Permission</h6></label>
                                        <Select
                                            value={permissionsList.find(perm => perm.permissionId === permissionId) ? {
                                                value: permissionId,
                                                label: permissionsList.find(perm => perm.permissionId === permissionId).permissionName
                                            } : null}
                                            onChange={(e) => {
                                                setPermissionId(e.value);
                                            }}
                                            placeholder="Select Permission"
                                            required
                                            options={permissionsList.map(perm => ({
                                                value: perm.permissionId,
                                                label: perm.permissionName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                {isEdit ?
                                    <>
                                        <div className="row">
                                            <div className="mb-10 col-md-2" style={{ paddingTop: "1rem" }}>
                                                <label className="form-label">Status</label>
                                            </div>
                                            <div className="mb-10 col-md-2" style={{ paddingTop: "1rem" }}>
                                                <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                                    <input
                                                        className="form-check-input text-end"
                                                        type="checkbox"
                                                        checked={rolePermissionStatus === '1'}
                                                        id="rolePermissionStatus"
                                                        onChange={(e) => {
                                                            setRolePermissionStatus(e.target.checked ? '1' : '0')
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </> : null
                                }
                                <ModalFooter>
                                    <Button
                                        className="btn-primary text-uppercase"
                                        variant="success"
                                        type="button"
                                        onClick={handleSubmit}
                                    >
                                        <b><i className="fas fa-save" />Save</b>
                                    </Button>
                                </ModalFooter>
                            </form>
                        </ModalBody>
                    </Modal>
                )
            }
        </>
    );
};

export default RolePermission;